import React from 'react';
import MuiButton, {
  ButtonProps as MuiButtonProps,
} from '@material-ui/core/Button';
import styled from 'styled-components';

import { styledSystem, StyledSystemProps } from '../styledSystem';

interface ButtonProps
  extends Omit<MuiButtonProps, 'color' | 'size'>,
    StyledSystemProps {
  color?:
    | 'primary'
    | 'secondary'
    | 'info'
    | 'warning'
    | 'error'
    | 'success'
    | 'default';
}

export const Button = styled(
  ({ color, size, variant, ...props }: ButtonProps) => (
    <MuiButton variant={variant ?? 'contained'} {...props} />
  )
)`
  &&& {
    border-radius: 35px;
    color: ${({ theme, color, variant }) =>
      theme.palette[color ? color : 'primary'][
        variant === 'outlined' ? 'main' : 'contrastText'
      ]};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    background-color: ${({ theme, color, variant }) =>
      theme.palette[color ? color : 'primary'][
        variant === 'outlined' ? 'contrastText' : 'main'
      ]};
    border-color: ${({ theme, color, variant }) =>
      variant === 'outlined'
        ? theme.palette[color ? color : 'primary'].main
        : null};
    &:hover {
      color: ${({ theme, color, variant }) =>
        theme.palette[color ? color : 'primary'][
          variant === 'outlined' ? 'contrastText' : 'contrastText'
        ]};
      background-color: ${({ theme, color, variant }) =>
        theme.palette[color ? color : 'primary'][
          variant === 'outlined' ? 'main' : 'dark'
        ]};
    }
    ${styledSystem}
  }
`;
